import { hasAnyFieldValue, validateWorkingHours } from "./workingHours";

export default { hasAnyFieldValue, validateWorkingHours };
